// extracted by mini-css-extract-plugin
export default {"subscriptionDetails":"PriceBreakdown_subscriptionDetails__h9iR0","spaceBetween":"PriceBreakdown_spaceBetween__bFqkS"};